import { render } from "./CardAbsence.vue?vue&type=template&id=0a766b0e&scoped=true"
import script from "./CardAbsence.vue?vue&type=script&lang=js"
export * from "./CardAbsence.vue?vue&type=script&lang=js"

import "./CardAbsence.vue?vue&type=style&index=0&id=0a766b0e&scoped=true&lang=css"

import exportComponent from "/var/www/driveapp2.locatiers.fr/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a766b0e"]])

export default __exports__